var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSketchfab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41524_1402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0028 1.10547C7.75447 1.10547 1.07031 7.79091 1.07031 16.0373C1.07031 24.2837 7.75447 30.97 16.0028 30.97C24.2512 30.97 30.9366 24.2837 30.9366 16.0373C30.9366 7.79091 24.2512 1.10547 16.0028 1.10547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.16288 0 0 7.16352 0 16C0 24.8365 7.16288 32 16 32C24.8371 32 32 24.8365 32 16C32 7.16352 24.8384 0 16 0ZM14.6099 25.5211L7.712 21.5394V13.5074L14.6099 17.232V25.5211ZM15.8387 15.3421L7.67744 11.016L15.8387 6.304L24.0013 11.016L15.8387 15.3421ZM24.0064 21.5547L17.1341 25.5227V17.264L24.0064 13.552V21.5547Z",
    fill: "#2B2B2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41524_1402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketchfab);
export default __webpack_public_path__ + "static/media/Sketchfab.2cf9d39c2aa4ca281acf3b733e31ce40.svg";
export { ForwardRef as ReactComponent };